export default __webpack_public_path__ + "static/media/TV_Sucesso.9e37e70a.png";